module.exports = __webpack_public_path__ + "img/slider-3.67c3dcd3.png";